import endpoints from '@app/src/api/endpoints'
import { FetchKey } from '@app/src/api/fetchHooks'
import useLocalisedCountryFilter from '@app/src/pages/ResourceCollection/Filters/Common/useLocalisedCountryFilter'
import Filter from '@app/src/pages/ResourceCollection/Filters/Filter'
import FilterFacetSelect from '@app/src/pages/ResourceCollection/Filters/FilterFacetSelect'
import { Operators } from '@app/src/pages/ResourceCollection/Filters/useFilters'
import React from 'react'
import { useIntl } from 'react-intl'

interface CountryFilterSelectProps {
  facetsEndpoint?: string
  facetsParamName?: string
  disableAutoFilter?: boolean
}

const CountryFilterSelect: React.FC<CountryFilterSelectProps> = ({
  facetsEndpoint = endpoints.countriesWithFacets,
  facetsParamName = 'iso3166Alpha2',
  disableAutoFilter = true,
}) => {
  const { formatMessage } = useIntl()
  const { renderOption, renderTags, customFilterOption, customSort } = useLocalisedCountryFilter()

  return (
    <Filter operator={Operators.In} name="country.id">
      {({ value, onChange, filterName }) => (
        <FilterFacetSelect
          size="small"
          multiple
          facetsParam={{
            key: [FetchKey.Provider, filterName],
            endpoint: facetsEndpoint,
            facetsParam: [{ name: facetsParamName }],
          }}
          renderOption={renderOption}
          renderTags={renderTags}
          filterName={filterName}
          filterOptions={customFilterOption}
          customSort={customSort}
          disableAutoFilter={disableAutoFilter}
          onChange={value => onChange(value)}
          fieldLabel={formatMessage({ id: 'schemas.filter.country.select' })}
          value={[value].flat()}
        />
      )}
    </Filter>
  )
}

export default CountryFilterSelect
